/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.Params1 = factory(root.ConferenceBackend.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Params1 model module.
   * @module model/Params1
   * @version 0.0.1
   */

  /**
   * Constructs a new <code>Params1</code>.
   * @alias module:model/Params1
   * @class
   * @param deviceId {String} 
   * @param questionId {String} 
   * @param optionId {String} 
   */
  var exports = function(deviceId, questionId, optionId) {
    var _this = this;

    _this['deviceId'] = deviceId;
    _this['questionId'] = questionId;
    _this['optionId'] = optionId;
  };

  /**
   * Constructs a <code>Params1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Params1} obj Optional instance to populate.
   * @return {module:model/Params1} The populated <code>Params1</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('deviceId')) {
        obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
      }
      if (data.hasOwnProperty('questionId')) {
        obj['questionId'] = ApiClient.convertToType(data['questionId'], 'String');
      }
      if (data.hasOwnProperty('optionId')) {
        obj['optionId'] = ApiClient.convertToType(data['optionId'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} deviceId
   */
  exports.prototype['deviceId'] = undefined;
  /**
   * @member {String} questionId
   */
  exports.prototype['questionId'] = undefined;
  /**
   * @member {String} optionId
   */
  exports.prototype['optionId'] = undefined;



  return exports;
}));






// WEBPACK FOOTER //
// ./generated/src/model/Params1.js